import { inject, Injectable } from '@angular/core';
import { EngagementRequest } from '@pages/talent-finder/models/request/engagement-request.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { EngagementLookups } from '@pages/talent-finder/models/request/engagement-lookups.interface';
import { EngagementsResponse } from '@pages/talent-finder/models/engagements/engagements-response.interface';
import { EngagementsFilterRequest } from '@pages/talent-finder/models/engagements/engagements-filter-request.interface';
import { IEngagementPreview } from '@pages/talent-finder/models/engagement-preview.interface';

@Injectable({
  providedIn: 'root',
})
export class EngagementsService {
  private readonly httpClient = inject(HttpClient);

  createEngagement(engagementRequest: EngagementRequest): Observable<void> {
    const url = 'api/v1/remote-it-security-management/engagements';

    return this.httpClient.post<void>(environment.portalApiUrl + url, engagementRequest);
  }

  editEngagement(id: string, engagementRequest: EngagementRequest): Observable<void> {
    const url = `api/v1/remote-it-security-management/engagements/${id}`;

    return this.httpClient.put<void>(environment.portalApiUrl + url, engagementRequest);
  }

  getHasAnyEngagements(): Observable<boolean> {
    const url = 'api/v1/remote-it-security-management/engagements/any';

    return this.httpClient.get<boolean>(environment.portalApiUrl + url);
  }

  getEngagementLookups(): Observable<EngagementLookups> {
    const url = 'api/v1/remote-it-security-management/lookups';

    return this.httpClient.get<EngagementLookups>(environment.portalApiUrl + url);
  }

  getEngagements(engagementsFilterRequest: EngagementsFilterRequest): Observable<EngagementsResponse> {
    const url = 'api/v1/remote-it-security-management/engagements/search';

    return this.httpClient.post<EngagementsResponse>(environment.portalApiUrl + url, engagementsFilterRequest);
  }

  getEngagement(id: string): Observable<IEngagementPreview> {
    const url = `api/v1/remote-it-security-management/engagements/${id}`;

    return this.httpClient.get<IEngagementPreview>(environment.portalApiUrl + url);
  }

  closeEngagement(id: string): Observable<void> {
    const url = `api/v1/remote-it-security-management/engagements/${id}/close`;

    return this.httpClient.put<void>(environment.portalApiUrl + url, null);
  }

  deleteEngagement(id: string): Observable<void> {
    const url = `api/v1/remote-it-security-management/engagements/${id}`;

    return this.httpClient.delete<void>(environment.portalApiUrl + url);
  }
}
